module.exports = __webpack_public_path__ + "static/media/booking.11fb8c49.svg";